import ActivityThisWeek from './ActivityThisWeek';

export default ActivityThisWeek;
